<td-wb-dropdown id="td-wb-account-performance-group"
                [panelMaxHeight]="310"
                [ngModel]="performanceGroup"
                (ngModelChange)="onPerformanceGroupChange($event)"
                [disabled]="isDisabled()"
                [name]="((performanceGroup.name === '$account') ? 'selectedAccountDropdown' : 'selectedGroupDropdown')"
                [ariaLabel]="((performanceGroup.name === '$account') ?
                 'tdWb.components.accountPerformanceGroupSelector.ACCOUNT_SELECTED_ARIA' :
                 'tdWb.components.accountPerformanceGroupSelector.ACCOUNT_GROUP_SELECTED_ARIA') | tdWbTranslate">
  <td-wb-dropdown-item [value]="accountGroupObject">
    <div>
      <span [innerText]="account().number"></span>
      <i>–</i>
      <span [innerText]="account().accountTypeDescription"></span>
    </div>
  </td-wb-dropdown-item>
  @for (group of accountPerformanceGroups() | slice:0:9; track group) {
    <td-wb-dropdown-item [value]="group">
      <div>
        <span [translate]="'tdWb.components.accountPerformanceGroupSelector.accountGroupTypes.' + group.name"></span>
      </div>
    </td-wb-dropdown-item>
  }
</td-wb-dropdown>
